export default "__VITE_ASSET__2049c213__"